import React from "react";
import { AlertTriangle } from "lucide-react";

// Error shown right next to the control it is about; flashes when it appears or changes.
export default function InlineAlert({ msg, testid, tone = "error" }) {
  if (!msg) return null;
  const c = tone === "error" ? "border-red-500/70 bg-red-500/15 text-red-100" : "border-amber-400/70 bg-amber-400/10 text-amber-100";
  return (
    <div key={msg} role="alert" data-testid={testid} className={`ax-flash rounded-lg border px-3 py-2 text-[13px] leading-snug font-medium flex gap-2 ${c}`}>
      <AlertTriangle className="w-4 h-4 shrink-0 mt-0.5" /><span>{msg}</span>
    </div>
  );
}
